// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".show-submenu-enter-active[data-v-92c52a02],\n.show-submenu-leave-active[data-v-92c52a02] {\n  transition: all 5s ease;\n}\n.show-submenu-enter[data-v-92c52a02],\n.show-submenu-leave-to[data-v-92c52a02] {\n  opacity: 0;\n  visibility: visible;\n}\n", ""]);
// Exports
module.exports = exports;
